import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";

export default class Scenario4Part5 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 1;
	chapterIds = {		
		scenario4_2b_s9: 'CALM - Scenario 4 - 2B - Segment 9',
		scenario4_2b_s10: 'CALM - Scenario 4 - 2B - Segment 10',
		
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part5.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MirandaApproaches();

	}

	private segment1Step1MirandaApproaches() {
		this.scenario.destroyAllUIInstances();
		//context.scenario.displayHeader();		
		var context = this;
		context.scenario.updateObjective('Receive update from Miranda');
		context.playVideoChapter(this.chapterIds.scenario4_2b_s9, () =>
			context.segment1Step2Dialogue())
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C10-L3-020b',
			[{
				text: 'No, go ahead and discharge him.',
				feedback: 'Discharging a patient involves ensuring certain patient care and needs have been met before the patient can be discharged. Making follow-up appointments, providing wound care instructions and materials, and taking an MRSA nasal swab are just some of the tasks that must be accomplished before a patient can be discharged. All these things, and possibly more, need to happen before the patient can be discharged',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'Review the discharge orders, referring to the Unit Discharge Checklist if available.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here				
				context.scenario.evaluateAnswer(selectedOption, () => 
				context.segment2Step1MirandaResponds(), 
				context.partIndx);
				
			}
		);
		context.scenario.updateObjective('Select your response to Miranda');
	}

	private segment2Step1MirandaResponds() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_2b_s10, () => {
			context.segment3Step1NSCDischargeChecklist();
		});
		context.scenario.updateObjective('Look up the Unit Discharge Checklist with Miranda');
	}

	private segment3Step1NSCDischargeChecklist() { // This interaction is just a scrollable text field with text		
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: { 
				text:
					`
			<p class="regular-description-font" style="margin: 0">
				<span style="color: rgb(222, 225, 156)">Unit Discharge Checklist</span> <br /><br />
				1. Make and print appointment(s). Include follow-up appointment for patients on Coumadin (warfarin).<br /><br />

				2. Email Inventory Manager to process rental equipment (bed or wound vac) for removal.<br /><br />
				
				3. Notify clothing room for patient’s belongings. Open till 4:30pm M-F. <br /><br />
				
				4. Review vital signs to ensure patient is stable for discharge.<br /><br />
				
				5. Collect MRSA culture and place in lab box.
				
				6. Review the latest Multi-D discharge planning note for needs that should be addressed before discharge.<br /><br />
				
				7. Review/document Flu vaccine.<br /><br />
				
				8. Review/document Pneumovac or Prevnar 13.<br /><br />
				
				9. Remove all invasive lines/tubes (Hep Lock) before discharge, when indicated.<br /><br />
				
				10. Remove telemetry monitor from patient, if applicable.<br /><br />
				
				11. Educate patient/family on medications such as warfarin, equipment, self-care, etc.<br /><br />
				
				12. Advise patient to pick up meds at pharmacy using ID bracelet/card.<br /><br />
				
				13. Ensure additional supplies/equipment are sent home with patient (wound care, enteral nutrition, prostheses equipment, etc.).<br /><br />
				
				14. Ensure patient belongings are packed and patient leaves with all money/personal items and clothing sheet signed by discharge RN.<br /><br />
				
				15. Arrange patient travel, if needed.<br /><br />
				
				16. Call report to receiving facility, if applicable.<br /><br />
				
				17. Complete nursing discharge note in CPRS.<br /><br />
				
				18. Address Interdisciplinary Plan of Care note.
			</p>
			`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.onDone();
			}
		})
	}	
}